<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="1200px" top="200px"
        :append-to-body="true">
        <div class="container">
            <div class="content">
                <div class="centerBox">
                    <div class="centerTop">
                        <div class="tabs">
                            <div class="tabs__item" v-for="(item, index) in tabList" :key="index"
                                @click="changeTab(item.value)" :style="{
                                    'border-bottom': activeName == item.value ? '1px solid #12618A' : 'none',
                                }">
                                <span>
                                    {{ item.label }}
                                </span>
                            </div>

                        </div>

                    </div>
                    <div class="info_box">
                        <preview1 ref="preview1" v-if="activeName == '0'"></preview1>
                        <preview2 ref="preview2" v-else @checkListChange="checkListChange"></preview2>
                    </div>

                </div>

            </div>
        </div>



    </el-dialog>
</template>

<script>
import preview1 from './preview1.vue'//课程
import preview2 from './detailPreview2.vue'//视频
export default {
    props: {

    },
    components: {
        preview1,
        preview2
    },
    data() {
        return {
            dialogVisible: false,
            title: '选择已有课程',
            tabList: [
                {
                    label: '课程信息',
                    value: '0'
                },
                {
                    label: '课程视频',
                    value: '1'
                },

            ],
            // 列表上方tab
            activeName: '0',
            recruitment_id:'',
            ruleForm: {
                "recruitment_id": '',
                // "audit_state": "1",
                'outline_id': '',//课程id
                course_ids: []//视频id数组
            },

            options: JSON.parse(localStorage.getItem('entinfolist')),
            infinite_loading: false,
            leftListTotal: 0,
            leftListCurrentPage: 0,
            leftListPagesize: 10,
            leftList: [],
            left_list_width: '240px',
            leftFoldshow: true,
            left_list_value: '',
            // 左侧列表参数
            postForm1: {
                page: 1,
                limit: 10,
                "outline_name": "",//名称
                "enterprise_id": '',//企业唯一标识
                // "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识

            },
            checkList: [],
            rules: {
                audit_fail_reason: [
                    { required: true, message: '请输入原因', trigger: 'blur' },

                ],
                audit_state: [
                    { required: true, message: '请选择审核结果', trigger: 'change' },
                ],
            }
        }
    },
    computed: {
        noMore() {
            return this.leftList.length >= this.leftListTotal && !this.infinite_loading
        },
        disabled() {
            return this.infinite_loading || this.noMore
        }
    },
    created() {

    },
    methods: {
        // 获取数据字典值
        async getDictsData(dict, optionsNmae) {
            let options = [];
            await this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: dict,
                    },
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        options = res.data.data.dictionary_detail;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
            this[optionsNmae] = options;
        },
        init(data) {
            this.activeName= '0'
            this.left_list_value=data.outline_id
            this.recruitment_id = data.recruitment_id
            this.$nextTick(() => {
                this.$refs.preview1.getData(this.left_list_value)
            })
            this.checkList = data.course_ids || []
        },
       
      
        // 左右列表点击收缩
        foldshowclick(type) {
            this[type + 'Foldshow'] = !this[type + 'Foldshow'];
            switch (this[type + 'Foldshow']) {
                case true:
                    this[type + '_list_width'] = type == "left" ? "240px" : "240px";

                    break;
                case false:

                    this[type + '_list_width'] = "35px";
                    break;
            }
        },
      
        handleClose(done) {

            done();

        },
        changeTab(value) {
            this.activeName = value;
            switch (this.activeName) {
                case '0':
                    this.$nextTick(() => {
                        this.$refs.preview1.getData(this.left_list_value)
                    })
                    break;
                case '1':
                    this.$nextTick(() => {
                        // 传递 isRead 状态和 checkList 到 preview2 组件
                        this.$refs.preview2.init(
                            this.left_list_value,
                            this.postForm1.enterprise_id,
                            this.recruitment_id,
                            this.checkList // 新增：传递默认勾选数据
                        )
                    })
                    break;
                default:
                    break;
            }
            // this.getList2(true)

        },
        checkListChange(value) {
            this.checkList = value
        },
      
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.postForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style scoped lang="less" src="./detail.less"></style>

